import { Page } from "@shared/pages/faq/faq-page";

export { getStaticProps } from "@shared/pages/faq/faq-page";

export default Page;
